import { Link } from "react-router-dom";
import { Mail, Phone, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { useLanguage } from "../i18n/LanguageContext";
import { chiSiamo } from "../i18n/chisiamo";
import { insights } from "../i18n/insights";

const Footer = () => {
  const { lang, t } = useLanguage();

  return (
    <footer data-testid="site-footer" className="bg-navy text-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="inline-block rounded-lg bg-white px-4 py-2.5">
              <Logo />
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60">{t.footer.tagline}</p>
            <a
              href="https://certificoqr.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-certificoqr-link"
              className="mt-6 inline-flex items-center gap-1.5 font-mono text-[0.7rem] uppercase tracking-[0.22em] text-emerald-400 hover:text-white transition-colors duration-300"
            >
              {t.footer.certifico}
              <ArrowUpRight className="h-3.5 w-3.5" />
            </a>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-mono text-[0.68rem] uppercase tracking-[0.28em] text-white/40">
              {t.footer.servicesTitle}
            </h4>
            <ul className="mt-5 space-y-3">
              {t.services.slice(0, 6).map((s) => (
                <li key={s.slug}>
                  <Link
                    to={s.path}
                    data-testid={`footer-service-${s.slug}`}
                    className="text-sm text-white/70 transition-colors duration-300 hover:text-white"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-mono text-[0.68rem] uppercase tracking-[0.28em] text-white/40">
              {t.footer.companyTitle}
            </h4>
            <ul className="mt-5 space-y-3">
              <li>
                <Link to="/" data-testid="footer-link-home" className="text-sm text-white/70 hover:text-white transition-colors duration-300">
                  {t.footer.home}
                </Link>
              </li>
              <li>
                <Link to="/chi-siamo" data-testid="footer-link-about" className="text-sm text-white/70 hover:text-white transition-colors duration-300">
                  {chiSiamo[lang].navLabel}
                </Link>
              </li>
              <li>
                <Link to="/approfondimenti" data-testid="footer-link-insights" className="text-sm text-white/70 hover:text-white transition-colors duration-300">
                  {insights[lang].navLabel}
                </Link>
              </li>
              <li>
                <Link to="/regolamento-ue" data-testid="footer-link-regulation" className="text-sm text-white/70 hover:text-white transition-colors duration-300">
                  {t.footer.regulation}
                </Link>
              </li>
              <li>
                <Link to="/contatti" data-testid="footer-link-contacts" className="text-sm text-white/70 hover:text-white transition-colors duration-300">
                  {t.footer.contacts}
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-mono text-[0.68rem] uppercase tracking-[0.28em] text-white/40">
              {t.footer.contactsTitle}
            </h4>
            <a
              href="mailto:info@aldebran.com"
              data-testid="footer-email-link"
              className="mt-5 flex items-center gap-2 text-sm text-white/70 transition-colors duration-300 hover:text-white"
            >
              <Mail className="h-4 w-4 text-[#4DA3FF]" />
              info@aldebran.com
            </a>
            <a
              href="tel:+390350167428"
              data-testid="footer-phone-link"
              className="mt-3 flex items-center gap-2 text-sm text-white/70 transition-colors duration-300 hover:text-white"
            >
              <Phone className="h-4 w-4 text-[#4DA3FF]" />
              +39 035 016 7428
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-7 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[0.68rem] tracking-[0.14em] text-white/40">{t.footer.rights}</p>
          <p className="font-mono text-[0.68rem] uppercase tracking-[0.28em] text-white/30">
            aldebran.com
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
